<script setup lang="ts">
import { computed, ref, watch, onMounted  } from 'vue'
import translaters from 'tradutors/assine';
import { localeStore } from 'stores/locale'
import { planCreditStore } from 'stores/planscredits'
import { planStore } from 'stores/plans'
import { assineChoiceStore } from 'stores/assineChoice'
import { event } from 'vue-gtag'
import { useRoute } from 'vue-router';
import api from '../../api';
import router from 'router'

const storeLocale = localeStore()
const storePlan = planStore()
const storePlanCredits = planCreditStore()
const storeAssineChoice = assineChoiceStore()
const emit = defineEmits(["showModalMessages"])
const route = useRoute()

const reactiveVoucher = computed(() => storePlan.voucher)
const reactiveCoupon = computed(() => storePlan.coupon)
const reactivePlans = computed(() => storePlan.plans)
const reactiveLocale = computed(() => storeLocale.locale) 
const reactivePlansCredits = computed(() => storePlanCredits.plansCredits)
const reactiveAssineChoice = computed(() => storeAssineChoice)

const formSubscribeItau = ref(null)
const cpf = ref(null)
const form = ref(null)
const code = ref('')
const loading = ref(false)
const acept = ref(false)
const descriptionTerm = ref(false)

const translate = computed(() => {
    if (reactiveLocale.value === 'pt-br') {
      return translaters.portugues
    } else {
      return translaters.ingles
    }
})

watch(reactiveLocale, () => {
    getTerms()
})

onMounted(() => {
    getTerms()
    eventGTM()    
})

function checkForm(formCheck: object) {
    if (!formCheck.cpf && reactiveLocale.value == 'pt-br') {
        error('CPF é obrigatório!')
        return false
    }

    if (!formCheck.acept) {
        error('Termos de uso é obrigatório!')
        return false
    }
    return true
}

function error(value) {
    emit('showModalMessages', {
        message: { show: true, title: 'Erro', textButton: 'Fechar', textBoby: value }
    })
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
        event: 'erro',
        erro: {
            tipo: value
        }
    })
}

function getValuePlan() {
    var planId = reactiveAssineChoice.value.choiceId
    let value = '0,00'    
    if (reactiveAssineChoice.value.choiceType == 'credits') {
        reactivePlansCredits.value.forEach( element => {
            if (element.id == planId) {
                value = element.discount > 0 && element.discount_value ? element.discount_value : element.value
            }
        })
    } else {
        reactivePlans.value.forEach( element => {
            if (element.id == planId) {
                value = element.discount > 0 && element.discount_value ? element.discount_value : element.value
            }
        })
    }    
    return value
}

function salvarForm(method: number) {
    event('checkout2', { method: 'Transferecia Itau' })
    loading.value = true

    form.value = {
        cpf: cpf.value,
        locale: reactiveLocale.value,
        plan: reactiveAssineChoice.value.choiceId,
        acept: acept.value,
        method
    }

    if (checkForm(form.value)) {
        form.value.coupon = route.query.coupon ?? reactiveCoupon.value ?? ''
        form.value.voucher = route.query.voucher ?? reactiveVoucher.value ?? ''
        var routeCheckout = reactiveAssineChoice.value.choiceType == 'credits' ? 'v1/subscribe/storeCreditsAssine' : 'v1/subscribe/storePaymentAssine'
        api
        .post(routeCheckout, form.value)
        .then(({ data }) => {
            if (!data.original.errors) {
                code.value = data.original.code
                window.open(
                    '',
                    'SHOPLINE',
                    'toolbar=yes,menubar=yes,resizable=yes,status=no,scrollbars=yes,width=815,height=575'
                )
                formSubscribeItau.value.submit()
            }

        })
        .catch(
            ({
            response: {
                data: { errors }
            }
            }) => error(errors)
        )
        .finally(() => (loading.value = false))
    } else {
        loading.value = false
    }
}

function eventGTM() {
    var value = getValuePlan()
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
        event: 'add_payment_info',
        payment: {
        acionador: route.query.acionador ?? 'link direto',
        tipo: reactiveAssineChoice.value.choiceType == 'credits' ? 'Crédito' : 'Assinatura',
        valor: value,
        currency: reactiveLocale.value === 'pt-br' ? 'BRL' : 'USD',
        forma: 'Transferecia Itau'
        }
    })
}

function getTerms() {
    api.get(`v1/subscribe/getTerms?language=${reactiveLocale.value}`).then(({ data: { terms: { description } } }) => {
        descriptionTerm.value = description
    })
}

</script>

<template>
  <div class="container-pay">
    <img
      src="https://api.belladasemana.com.br/storage/br/assine-itau-shopline.png"
      alt="Itau Shopline"
      width="121"
      height="36"
    />
    <div class="row my-3 justify-content-center">
      <div class="col-10">
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            name="cpf"
            :placeholder="translate.cpfCreditCards"
            v-model="cpf"
            v-maska
            data-maska="###.###.###-##"
          />
          <form
            id="form-subscribe-itau"
            ref="formSubscribeItau"
            action="https://shopline.itau.com.br/shopline/shopline.aspx"
            method="POST"
            target="SHOPLINE"
          >
            <input type="hidden" name="DC" v-model="code" id="itau-code" />
          </form>
        </div>
      </div>
      <div class="col-10">
        <span class="legend mt-3" v-html="translate.legendFormTransfer"></span>
      </div>
      <!--Terms BEGIN-->
      <div class="pt-3">
        <vue-collapsible-panel-group base-color="#2d2b3b">
            <vue-collapsible-panel :expanded="false">
                <template #title class="">
                    <div class="title-terms">{{ translate.titleTermsUse}}</div>
                </template>
                <template #content>
                    {{ ' ' }}
                    <div class="col-12 ">
                        <span v-html="descriptionTerm"></span>
                    </div>
                </template>
            </vue-collapsible-panel>
        </vue-collapsible-panel-group>
      </div>
      <div class="pt-3 pb-3">
            <input type="checkbox" name="acept" id="acept" v-model="acept" />
            <label for="checkbox" class="acept-text">{{ translate.aceitlabel }}</label>
      </div>
      <!--Terms END-->      
      <div class="text-center mt-3" v-if="loading">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div v-else class="col-12 mt-3 d-flex justify-content-center">
        <button class="d-w-btn" type="submit" @click="salvarForm(4)">Concluir Compra</button>
      </div>
    </div>
  </div>    
</template>

<style scoped lang="css">
.container-pay {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.form-group input {
    padding: 15px 20px;
    border-radius: 5px;
    margin-bottom: 15px;
    background-color: #fff;
    font-size: small;
}

.form-control:focus {
    color: #000;
    background-color: #f8f8f8;
}

.legend {
    font-size: 12px;
    width: 50%;
    color: gray;
    text-align: center;
}

.d-w-btn {
    color: #fff;
    padding: 10px 30px;
    background: #050505;
    border-radius: 30px;
    display: flex;
    justify-content: center;
    min-width: 210px;
    align-items: center;
    font-family: 'Exo-2';
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 19px;
}
.vcpg {
  border: none !important;
}

.vcpg :deep(.vcp__header) {
  border-radius: 10px;
  background-color: #F5F5F5 !important;
  margin-top: 10px;
  padding: 26px;
  border: 1px solid var(--border-color);
}

.title-terms {
    font-family: 'Exo-2';
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    color: #0B0B0B;
}

.acept-text {
    font-family: 'Exo-2';
    font-weight: 400;
    font-size: 16px;
    line-height: 28px;
    color: #4B4B4B;
}

input[type=checkbox]:before {
    content: "";
    display: block;
    position: absolute;
    width: 30px;
    height: 30px;
    border-radius: 8px;
    top: -3px;
    left: -3px;
    background-color: unset; 
}

input[type=checkbox]:checked:after {
    border: unset;
}

/* regras mobile 769px */
@media screen and (max-width: 769px) {

}

</style>